import React, { useState } from "react";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import { Modal } from "components/atoms/Modal";
import { Span, Title } from "utils/styling/typography.styled";
import * as Styled from "./CreateFolderModal.styled";
interface CreateFolderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (folderName: string) => void;
  text: string;
}
const CreateFolderModal: React.FC<CreateFolderModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  text
}) => {
  const [folderName, setFolderName] = useState("");
  const handleFolderNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFolderName(e.target.value);
  };
  const handleSubmit = () => {
    onSubmit(folderName.trim());
    setFolderName("");
  };
  return <Modal open={isOpen} handleBackdropClick={onClose} disableBackdropClick data-sentry-element="Modal" data-sentry-component="CreateFolderModal" data-sentry-source-file="index.tsx">
            <Styled.ModalContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">{text}</Title>
                <Styled.FormGroup data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Label htmlFor="folderName" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        Folder Name:
                    </Styled.Label>
                    <Styled.Input id="folderName" type="text" value={folderName} onChange={handleFolderNameChange} placeholder="Enter folder name" data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
                </Styled.FormGroup>
                <Styled.ButtonContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Button type="button" variant={ButtonType.SUCCESS} onClick={handleSubmit} disabled={!folderName.trim()} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Submit</Span>
                    </Button>
                    <Button type="button" variant={ButtonType.PRIMARY} onClick={onClose} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Cancel</Span>
                    </Button>
                </Styled.ButtonContainer>
            </Styled.ModalContainer>
        </Modal>;
};
export default CreateFolderModal;